import type {
  UseCashbackCampaignsContext,
  UseCombinedCampaignsContext,
  UseTourOperatorDiscountCampaignsContext,
  UseCampaignBannerContext,
  UseGenericBannerContext,
} from '@/modules/common/hooks/useCampaigns/types';

import {createContext} from 'react';

const initialTourOperatorDiscountCampaignsContext: UseTourOperatorDiscountCampaignsContext =
  {
    filterInterceptorContent: {
      highlight: '',
      text: '',
    },
    campaign: null,
    getAssociatedDiscountCampaign: () => null,
    handleTourOperatorDiscountCampaignBannerClick: () => undefined,
    shouldShowBanner: false,
    isLoadingCampaigns: true,
    shouldShowFilter: false,
  };

export const tourOperatorDiscountCampaignContext =
  createContext<UseTourOperatorDiscountCampaignsContext>(
    initialTourOperatorDiscountCampaignsContext
  );

const initialCashbackCampaignsContext: UseCashbackCampaignsContext = {
  campaign: null,
  shouldShowBanner: false,
  isLoadingCampaigns: true,
};

export const cashbackCampaignContext =
  createContext<UseCashbackCampaignsContext>(initialCashbackCampaignsContext);

const initialCombinedCampaignsContext: UseCombinedCampaignsContext = {
  shouldShowInterceptor: false,
  discountCampaign: null,
  shouldShowBanner: false,
  isLoadingCampaigns: true,
  combinedCampaign: null,
  handleTourOperatorDiscountCampaignBannerClick: () => undefined,
};

export const combinedCampaignContext =
  createContext<UseCombinedCampaignsContext>(initialCombinedCampaignsContext);

const initialCampaignBannerContext: UseCampaignBannerContext = {
  campaign: null,
  shouldShowBanner: false,
  isLoadingCampaigns: true,
};

export const campaignBannerContext = createContext<UseCampaignBannerContext>(
  initialCampaignBannerContext
);

const initialGenericBannerContext: UseGenericBannerContext = {
  campaign: null,
  shouldShowBanner: false,
  isLoadingCampaigns: true,
};

export const genericBannerContext = createContext<UseGenericBannerContext>(
  initialGenericBannerContext
);
